import Dropdown from '../components/Dropdown';
import LabelWithTooltip from '../components/LabelWithTooltip';
import React from 'react';
import { initialConfiguration } from '../features/Devices/constants/constants';

const ControllerFormFields = ({ setDeviceToEdit, deviceToEdit }) => {
  // проверка серийного номера: определение стандартности контроллера:

  const setIntervalType = (e) => {
    const defaultWriteEvery = getWritingIntervals(e)?.[0]?.val || 1;
    setDeviceToEdit({
      ...deviceToEdit,
      config: { ...deviceToEdit?.config, write_every: defaultWriteEvery, conn_rule: [...deviceToEdit?.config?.conn_rule?.map((r, i) => (i === 0 ? e : 1))] },
    });
  };

  const getWritingIntervals = (period) => {
    switch (period) {
      case 'W':
        return initialConfiguration.writingIntervalsPerWeek;
      case 'M':
        return initialConfiguration.writingIntervalsPerMonth;
      default:
        return initialConfiguration.writingIntervals;
    }
  };

  return (
    <>
      <Dropdown
        className={'w-full mt-4'}
        label={<LabelWithTooltip text={'Интервал записи показаний'} tooltipText={'Как часто устройство будет\n записывать показания в свою память'} />}
        options={getWritingIntervals(deviceToEdit?.config?.conn_rule?.[0])}
        value={deviceToEdit?.config?.write_every}
        inputCb={(e) =>
          setDeviceToEdit({
            ...deviceToEdit,
            config: {
              ...deviceToEdit?.config,
              write_every: parseInt(e.target.value),
            },
          })
        }
        id="int"
        valkey="val"
        optkey="opt"
      />
      <Dropdown
        className={'w-full mt-4'}
        label={
          <LabelWithTooltip
            text={'Интервал отправки показаний в ЛК'}
            tooltipText={'Как часто устройство будет передавать\n записанные показания в личный кабинет'}
          />
        }
        options={initialConfiguration.intType}
        value={deviceToEdit?.config?.conn_rule?.[0]}
        inputCb={(e) => setIntervalType(e.target.value)}
        id="inttype"
        valkey="val"
        optkey="opt"
      />

      {deviceToEdit?.config?.conn_rule?.[0] === 'D' && (
        <>
          <Dropdown
            className={'w-full my-4'}
            label={'Время отправки показаний'}
            options={initialConfiguration.sendHrs}
            value={deviceToEdit?.config?.conn_rule?.[2]}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                config: {
                  ...deviceToEdit.config,
                  conn_rule: [...deviceToEdit.config?.conn_rule?.map((r, i) => (i === 2 ? parseInt(e.target.value) : r))],
                },
              })
            }
            id="hrs"
            valkey="val"
            optkey="opt"
          />
        </>
      )}
      {deviceToEdit?.config?.conn_rule?.[0] === 'W' && (
        <>
          <Dropdown
            className={'w-full my-4'}
            label={'День недели'}
            options={initialConfiguration.weekDay}
            value={deviceToEdit?.config?.conn_rule?.[1]}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                config: {
                  ...deviceToEdit.config,
                  conn_rule: [...deviceToEdit.config?.conn_rule?.map((r, i) => (i === 1 ? parseInt(e.target.value) : r))],
                },
              })
            }
            id="hrs"
            valkey="val"
            optkey="opt"
          />
          <Dropdown
            className={'w-full my-4'}
            label={'Время отправки показаний'}
            options={initialConfiguration.sendHrs}
            value={deviceToEdit?.config?.conn_rule?.[2]}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                config: {
                  ...deviceToEdit.config,
                  conn_rule: [...deviceToEdit.config?.conn_rule?.map((r, i) => (i === 2 ? parseInt(e.target.value) : r))],
                },
              })
            }
            id="hrs"
            valkey="val"
            optkey="opt"
          />
        </>
      )}
      {deviceToEdit?.config?.conn_rule?.[0] === 'M' && (
        <>
          <Dropdown
            className={'w-full my-4'}
            label={'День месяца'}
            options={initialConfiguration.monthdays}
            value={deviceToEdit?.config?.conn_rule?.[1]}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                config: {
                  ...deviceToEdit.config,
                  conn_rule: [...deviceToEdit.config?.conn_rule.map((r, i) => (i === 1 ? parseInt(e.target.value) : r))],
                },
              })
            }
            id="hrs"
            valkey="val"
            optkey="opt"
          />
          <Dropdown
            className={'w-full my-4'}
            label={'Время отправки показаний'}
            options={initialConfiguration.sendHrs}
            value={deviceToEdit?.config?.conn_rule?.[2]}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                config: {
                  ...deviceToEdit.config,
                  conn_rule: [...deviceToEdit.config?.conn_rule?.map((r, i) => (i === 2 ? parseInt(e.target.value) : r))],
                },
              })
            }
            id="hrs"
            valkey="val"
            optkey="opt"
          />
        </>
      )}
    </>
  );
};

export default ControllerFormFields;
